import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MENU_LIST } from '../../../shared/constansts/app.const';

@Component({
  selector: 'app-settings-container',
  templateUrl: './settings-container.component.html',
  styleUrl: './settings-container.component.scss'
})
export class SettingsContainerComponent extends BaseComponent implements OnInit{
  menuList = MENU_LIST;
 
  ngOnInit(): void {

  }
}
